import { create } from 'zustand';

type ChatWidgetMorphState = {
  /** Set by whoever changes the layout when the morph would show the wrong shape. */
  suppressed: boolean;
};

const useStore = create<ChatWidgetMorphState>()(() => ({ suppressed: false }));

/**
 * Skip the next presentation morph. It grows one undivided box to the shape the chat is taking,
 * which is wrong when the chat is landing beside a browser pane; suppressed, the layout changes.
 */
const suppressNextChatWidgetMorph = () => useStore.setState({ suppressed: true });

/** Reads the flag without consuming it, for code that runs before the morph decides. */
const peekChatWidgetMorphSuppressed = (): boolean => useStore.getState().suppressed;

const takeChatWidgetMorphSuppressed = (): boolean => {
  const { suppressed } = useStore.getState();
  if (suppressed) useStore.setState({ suppressed: false });
  return suppressed;
};

export { peekChatWidgetMorphSuppressed, suppressNextChatWidgetMorph, takeChatWidgetMorphSuppressed };
